import { Icon20PaymentCardOutline, Icon20PicturePlusOutline, Icon20PictureStackOutline } from '@vkontakte/icons';
import React from 'react';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { closeCommonWhatsNewDialog, renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { renderVigboPrintFakedoorModal } from 'reactApp/ui/VigboPrintFakedoor/VigboPrintFakedoorModal';
import { createDwhTemplatedSender } from 'reactApp/utils/dwh';

import styles from './VigboPrintModal.css';

const sendRadar = createDwhTemplatedSender({ eventCategory: 'vigbo_modal_details', replacementSymbol: '_' });

export const renderVigboPrintModal = () => {
    const title = 'Печать фотокниг от Облака и Vigbo';
    const primaryButtonText = 'Попробовать';
    const bulletedContent = [
        { icon: <Icon20PictureStackOutline />, text: 'Выберите альбом или фотографии, которые хотите напечатать' },
        { icon: <Icon20PicturePlusOutline />, text: 'Вы окажетесь на сайте нашего партнёра Vigbo – он запросит доступ к фото' },
        { icon: <Icon20PaymentCardOutline />, text: 'Выберите формат фотокниги, способ получения и оплатите заказ' },
    ];

    const onShow = () => {
        sendRadar({
            action: 'fakedoor_show',
        });
    };

    const onClick = () => {
        sendRadar({
            action: 'fakedoor_click',
        });

        closeCommonWhatsNewDialog();
        renderVigboPrintFakedoorModal();
    };

    const onClose = () => {
        sendRadar({
            action: 'fakedoor_close',
        });

        closeCommonWhatsNewDialog();
    };

    renderCommonWhatsNewDialog({
        dialogSize: 'large',
        buttonTheme: 'vk',
        title,
        primaryButtonText,
        bulletedContent,
        imageUrl: `${cdnPackagesUrl}/static/cloud/vigbo/print/fakedoor/modal.webp`,
        imageWrapperClassName: styles.imageWrapper,
        onClick,
        onClose,
        onShow,
        closeIconClassName: styles.closeIcon,
    });
};
